/**
 * Bookmark catcher for the old customer map dashboard URL, which the unified
 * customer map replaces. Sends `/c/:cust_id/dashboards/map` to that customer's
 * map — react-router's `Navigate` does not interpolate params into a bare
 * pattern string, so the target is built from the route params directly.
 */
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { customerMapPath } from '@sophocles/router/paths';

function CustomerMapRedirect() {
  const { cust_id } = useParams();
  return <Navigate to={customerMapPath({ cust_id })} replace />;
}

export default CustomerMapRedirect;
